<h2 mat-dialog-title>
  <mat-icon>inventory</mat-icon>
  Insumos Requeridos | {{ procedureData?.name }}
</h2>

<mat-dialog-content class="mat-typography">
  <div class="procedure-info">
    <p><strong>Procedimiento:</strong> {{ procedureData?.name }}</p>
    <p><strong>Código:</strong> {{ procedureData?.code }}</p>
    <p><strong>Especialidad:</strong> {{ procedureData?.specialty_name }}</p>
  </div>

  <mat-divider></mat-divider>

  <div class="actions-container">
    <button
      mat-raised-button
      color="primary"
      (click)="openAddProductForm()">
      <mat-icon>add</mat-icon> Agregar Insumo
    </button>

    <button
      mat-raised-button
      color="primary"
      matTooltip="Recargar insumos disponibles"
      (click)="loadAvailableProducts()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- Mensaje cuando no hay productos -->
  @if (requirements.length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-icon">inventory_2</mat-icon>
      <h3>No hay insumos requeridos</h3>
      <p>Agregue los insumos necesarios para realizar este procedimiento</p>
    </div>
  }

  <!-- Tabla de productos -->
  @if (requirements.length > 0) {
    <div>
      <app-custom-table
        [config]="tableConfig"
        [data]="requirements"
        (sentValue)="action($event)">
      </app-custom-table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    (click)="close()">
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()">
    <mat-icon>save</mat-icon> Guardar Insumos
  </button>
</mat-dialog-actions>